import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginRoute = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogin = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const u = urlParams.get('u');
            const htr = urlParams.get('htr');

            const cookiesAccepted = JSON.parse(localStorage.getItem('cookiesAccepted'));
            if (!cookiesAccepted || cookiesAccepted.accepted !== true) {navigate('/'); return;}

            if (u && htr) {
                const cleanHtr = decodeURIComponent(htr);

                document.cookie = `u=${u}; path=/;`;
                document.cookie = `htr=${cleanHtr}; path=/;`;

                setTimeout(() => {navigate('/dashboard/@home/');}, 100);
            } else {window.location.href = 'https://jaquesbot.app/api/V4/botConfig/intraConnect/panelAuth/authorize';}
        };
        handleLogin();
    }, [navigate]);

    return null;
};

export default LoginRoute;
